var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("layout-8", {
        staticStyle: { width: "100%", height: "calc(100vh - 50px)" },
        attrs: {
          table_name: "Job Orders",
          filter_options: _vm.filters,
          id: _vm.pageid,
          searchbar: true,
          navbar: true,
          nav_items: ["Save"],
          nav_item_perms: ["44"],
          button_perm: "44",
          button_name: "Select",
          term: _vm.term,
          reroute: "/0310",
          select_reroute: true
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1267d27e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1267d27e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Scheduling.vue
// module id = 552
// module chunks = 0